import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueResource from 'vue-resource'

import App from './App'
import router from './router'

import { Icon } from 'leaflet';

Vue.use(VueResource)
Vue.use(BootstrapVue)

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// avoid ajax for it more than one.
Vue.prototype.globs = {
	districts: null,
	counties: null,
	fire_dep_counties: null,
	police_sta_counties: null,
	hypermarkets_counties: null,
}
Vue.prototype.assets_url = process.env.VUE_APP_PUBLIC_PATH;

Vue.http.options.root = process.env.VUE_APP_API_URL;
Vue.http.headers.common['X-App-Client'] = 'TRUE';
Vue.http.headers.common['X-Requested-With'] = 'XMLHttpRequest';

Vue.mixin({
	computed: {
		base_url: function() {
			return '/' +this.$lang;
		}
	},
	methods: {
		get_starter_item(items, id_starter) {
			if(typeof id_starter === 'undefined') {
				return items[Math.floor(Math.random()*items.length)];
			}
			let item = items.find((item) => item.id == id_starter);
			if(typeof item === 'undefined') {
				this.abort_404();
				throw new Error('Stop right there'); // stop execution
			}
			if(typeof id_starter === 'number')
				item.id = item.id.toString(); // toogle to trigger init_comp watch
			else
				item.id = Number(item.id); // toogle to trigger init_comp watch
			return item;
		},
		choose_item_search1: function(item) {
			if(typeof item !== 'undefined') {
	             this.search1.value = item.name; // "this" is the vue instance caller
	             this.id_item_selected = item.id;
	             this.search1.has_error = false;
			}
	    },
		is_mobile: function() {
			return window.innerWidth < 992;
		},
		abort_404: function() {
			router.push({name: 'Error_404', params: {lang: Vue.prototype.$lang}});
		},
		get_random_ele: function(items) {
			return Math.floor(Math.random() * items.length) + 1;
		},
		get_req: function(url, before_callback, success_callback, fail_callback, always_callback)  {
			Vue.http.get(url+'?'+new Date().getTime() /* prevent cache */, { 
			headers: {'X-App-Lang': this.$lang},
			before(request) {
				before_callback(request);
			}
			}).then(response => {
				success_callback(response);
			}, response => {
				fail_callback(response);
			}).then(response => {
				always_callback(response);
			});
		},
		post_req: function(url, data, before_callback, success_callback, fail_callback, always_callback)  {
			Vue.http.post(url, data, { 
			headers: {'X-App-Lang': this.$lang},
			before(request) {
				before_callback(request);
			}
			}).then(response => {
				success_callback(response);
			}, response => {
				fail_callback(response);
			}).then(response => {
				always_callback(response);
			});
		},
		trans: function(key, trans_key) {
			if(typeof this.$trans[trans_key][key] !== 'undefined')
				return this.$trans[trans_key][key];
			return 'undefined';
		},
		set_url: function(url, page_title, set_history) {
			/*if(set_history)
				history.pushState({}, '', url);*/
			// document.title = window.laravel.app_name+ ' - ' +page_title;
			/*ga('set', 'page', '/new-page.html');
			ga('send', 'pageview');*/
		},
		string_to_slug: function(str) {
			str = str.replace(/^\s+|\s+$/g, ''); // trim
			str = str.toLowerCase();

			var from = "ãàáäâèéëêìíïîòõóöôùúüûñç·/_,:;";
			var to   = "aaaaaeeeeiiiiooooouuuunc------";
			for (var i=0, l=from.length ; i<l ; i++) {
				str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
			}

			str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
			.replace(/\s+/g, '-') // collapse whitespace and replace by -
			.replace(/-+/g, '-'); // collapse dashes

			return str;
		},
		get_version: function(resolve) {
			Vue.http.get('version?'+new Date().getTime()).then(response => {
				var server_time = response.body.split('$')[1].replace(/[^0-9\.]/g, '');
				var hash_lol = '';
				const letters = 'acegilnprt';
				for(var i=0; i < server_time.length; i++) {
					hash_lol += letters[server_time[i]]+ 'y&$';
				}
				Vue.http.headers.common['X-Auth-Token'] = hash_lol;
				const that = this;
				setTimeout(function(){that.get_version(null)}, 10000);
				if(resolve != null) {
					resolve();
				}
			}, response => {
				window.location.reload();
			});
		},
		promise_version: function() {
			return new Promise((resolve, reject) => {
				this.get_version(resolve);
			})
		}
	},
});

/*Vue.component(
  'g-map', 
  () => import( webpackChunkName: "g_map"  '@/views/sub_components/G_Map.vue')
);*/

Vue.component(
  'loader', 
  () => import(/* webpackChunkName: "loader" */ '@/views/sub_components/Loader.vue')
);

Vue.component(
  'modal', 
  () => import(/* webpackChunkName: "modal" */ '@/views/sub_components/Modal.vue')
);

Vue.component(
  'datatable', 
  () => import(/* webpackChunkName: "datatable" */ '@/views/sub_components/Table.vue')
);

Vue.component(
  'bar-chart', 
  () => import(/* webpackChunkName: "bar_chart" */ '@/views/sub_components/Bar_Chart.vue')
);

Vue.component(
  'line-chart', 
  () => import(/* webpackChunkName: "line_chart" */ '@/views/sub_components/Line_Chart.vue')
);

Vue.component(
  'pie-chart', 
  () => import(/* webpackChunkName: "line_chart" */ '@/views/sub_components/Pie_Chart.vue')
);

Vue.component(
  'autosuggest', 
  () => import(/* webpackChunkName: "autosuggest" */ '@/views/sub_components/Autosuggest.vue')
);

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});

/* eslint-disable no-new */
/*Vue.options.methods.promise_version().then(() => {
	new Vue({
	  el: '#app',
	  router,
	  template: '<App/>',
	  components: { App },
	});
});*/